import { BaseStoredItem } from "./BaseStoredItem";
import { isPostcodeValid } from "../containers/PostcodeContainer/Postcode";

export class StoredPostcode extends BaseStoredItem<string> {
  set(postcode: string) {
    if (isPostcodeValid(postcode)) {
      return this.storeData(postcode);
    }

    return Promise.resolve();
  }

  storageKey() {
    return "postcode";
  }
}
